// Hook used to determine any service is set, or if every service is required/visisble (item === true)
const isVisibleOrRequired = (services, selectedServ) =>
    services.some((item) => selectedServ.includes(item) || item === true);

export default isVisibleOrRequired;
